import { combineReducers } from "redux";
import Authentication from "./authentication";
import languageAction from './languageAction';

export default combineReducers({
  Authentication:Authentication,
  LanguageAction:languageAction
});
